import React from 'react'
import get from 'lodash/get'
import { useQuery } from 'react-query'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { formatCurrency, setLocaleFromCountry } from 'supporticon/utils/numbers'
import { fetchPage, deserializePage } from 'supporticon/api/pages'
import { selectLocalisation } from '../../../store/site'
import { useDonation } from '../../utils/use-donation'
import { withRouter } from 'react-router'
import dayjs from 'dayjs'
import numbro from 'numbro'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Content from '../../ui/Content'
import Error from '../../ui/Error'
import Icon from 'constructicon/icon'
import LeaderboardItem from 'constructicon/leaderboard-item'
import Loading from '../../ui/Loading'
import Section from '../../ui/Section'

const DonationDetail = ({
  alignment,
  backgroundImage,
  background,
  classNames,
  copy,
  country,
  foreground,
  layout,
  router,
  size,
  spacing,
  title
}) => {
  const donationId = router.location.query['donation-id']

  if (!donationId) return null

  const { data: donation, status } = useDonation(donationId)

  const { data: page, isSuccess: isPageFetched } = useQuery(
    ['page', get(donation, 'page')],
    () => fetchPage(donation.page).then(deserializePage),
    {
      enabled: !!get(donation, 'page'),
      staleTime: 30000
    }
  )

  const renderAmount = (amount, currency) =>
    formatCurrency({
      amount,
      currencyCode: currency,
      locale: setLocaleFromCountry(country)
    })

  return (
    <Section
      alignment={alignment}
      backgroundImage={backgroundImage}
      background={background}
      foreground={foreground}
      size={size}
      spacing={spacing}>
      <Content
        layout={layout}
        title={title}>
        {status === 'loading' && <Loading />}
        {status === 'error' && <Error />}
        {status === 'success' && (
          <div className={classNames.root}>
            <div className={classNames.detail}>
              {donation.amount
                ? `${donation.name} donated ${renderAmount(donation.amount, donation.currency)}`
                : `${donation.name} made a donation`}
            </div>
            <div className={classNames.meta}>
              <div>{dayjs(donation.createdAt).fromNow()}</div>
              {!!donation.giftAidAmount && (
                <div>{`${renderAmount(donation.giftAidAmount, donation.currency)} Gift Aid`}</div>
              )}
            </div>
            {donation.message && (
              <div className={classNames.message}>
                {donation.message}
              </div>
            )}
            {donation.status === 'Pending' && (
              <div className={classNames.status}>
                <Icon name='warning' />
                <span>Please note this donation is still processing</span>
              </div>
            )}
            {isPageFetched && (
              <>
                <div className={classNames.label}>Donation made to</div>
                <div className={classNames.page}>
                  <LeaderboardItem
                    amount={numbro(page.raised).formatCurrency('0,0.[00]')}
                    background='light'
                    borderWidth={1}
                    foreground='dark'
                    image={page.image}
                    href={page.url}
                    spacing={0.666}
                    subtitle={page.charity.name}
                    title={page.name}
                  />
                </div>
              </>
            )}
          </div>
        )}
      </Content>
    </Section>
  )
}

const mapStateToProps = (state) => ({
  ...selectLocalisation(state)
})

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
  withRouter
)(DonationDetail)
